import { render, staticRenderFns } from "./NewProductCategories.vue?vue&type=template&id=43f1348e&scoped=true"
import script from "./NewProductCategories.vue?vue&type=script&lang=js"
export * from "./NewProductCategories.vue?vue&type=script&lang=js"
import style0 from "./NewProductCategories.vue?vue&type=style&index=0&id=43f1348e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f1348e",
  null
  
)

export default component.exports